import React from "react";
// Customizable Area Start
import RevenueController, { Props } from "./RevenueController.web";
import NavigationMenu from "../../navigationmenu/src/NavigationMenu.web";
import { Box, IconButton, Typography } from "@material-ui/core";
import RightSideBar from "../../activityfeed/src/RightSideBar.web";
import { backArrowDark, backArrowWhite } from "../../groups/src/assets";
import { comingSoonIcon } from "./assets";

// Customizable Area End

export default class RevenueScreen extends RevenueController {
    constructor(props: Props) {
        super(props);
        // Customizable Area Start
        // Customizable Area End
    }
    // Customizable Area Start

    // Customizable Area End

    render() {
        // Customizable Area Start
        const { checked, navigation } = this.props
        return (
            <NavigationMenu id="" tabItem="Earnings" checked={checked} navigation={navigation}>
                <Box style={webStyles.wrapper}>
                    <Box style={webStyles.rightPane}>
                        <Box style={webStyles.headerRow}>
                            <IconButton onClick={this.navigateToEarnigs} data-test-id='back-btn'>
                                <img src={checked ? backArrowDark : backArrowWhite} style={{ width: '24px', height: '24px' }} />
                            </IconButton>
                            <Typography style={{ ...webStyles.headerLabel, color: checked ? '#222222' : '#fff' }}>{navigation.getParam('type')}</Typography>
                        </Box>
                        <Box style={webStyles.containerView}>
                            <img src={comingSoonIcon} style={{ width: '335px', height: '48px' }} />
                        </Box>
                    </Box>

                    <RightSideBar checked={checked} navigation={navigation} />
                </Box>
            </NavigationMenu>
        );
        // Customizable Area End
    }
}

// Customizable Area Start
const webStyles = {
    wrapper: {
        width: "100%",
        display: "flex",
    },
    rightPane: {
        display: "flex",
        flexDirection: "column",
        padding: '24px',
        width: '60%',
        "@media (max-width:1000px)": {
            width: "80%",
        },
    } as React.CSSProperties,
    headerRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    } as React.CSSProperties,
    headerLabel: {
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: 800,
        fontFamily: 'Manrope',
    },
    containerView: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 'auto',
    }
}

// Customizable Area End
